import React from "react";

const Loading = () => {
  return (
    <div className="flex-center">
      {/*  */}

      <div className="loader ">
        <br />
        <br />
        <br />
        <div
          className="flex-center"
          style={{ fontSize: "18px", color: "teal" }}
        >
          <b>Loading...</b>
        </div>
        <br />
        
        {/*  */}
        <div className="flex-center" id="ld2">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
        {/*  */}
      </div>

      {/*  */}
    </div>
  );
};

export default Loading;
